import * as RequestStatus from '../actions/constants/RequestStatus';
import { isAppAuthSelector } from './AuthSelectors';
import { numContactsInCrmSelector } from './ContactsSelectors';
import { marketingContactsOnRenewalSelector } from './MarketingContactsSelectors';
import { fetchProductInventoryStatus } from './ProductInventorySelectors';
import { fetchProductsStatus } from './ProductsSelectors';
import { fetchPromotionsStatus } from './PromotionSelectors';
import { fetchPurchaseMotionStatus } from './PurchaseMotionSelectors';
import { fetchRequiredOnboardingStatus } from './RequiredOnboardingSelectors';
import { fetchSeatsInventoryStatus } from './SeatsInventorySelectors';

const numContactsSucceededCheck = state => {
  const numContactsInCrm = numContactsInCrmSelector(state);
  return numContactsInCrm !== null;
};

const marketingContactsOnRenewalSucceededCheck = state => {
  const isInApp = isAppAuthSelector(state);

  if (!isInApp) {
    return true;
  }

  const marketingContactsOnRenewal = marketingContactsOnRenewalSelector(state);
  return marketingContactsOnRenewal !== null && marketingContactsOnRenewal !== undefined;
}; // current required endpoint successes for page load success:
// products, promotions, required onboarding
// & numContactsInCrm, but only if on Marketing Hub Page


export const hasPricingAndPurchasingSucceededSelector = state => {
  const {
    promotions
  } = state;
  const isInApp = isAppAuthSelector(state);
  const requiredOnboardingStatus = fetchRequiredOnboardingStatus(state);
  const productsStatus = fetchProductsStatus(state);
  const ownershipComplete = fetchProductInventoryStatus(state) === RequestStatus.SUCCEEDED || !isInApp;
  return productsStatus === RequestStatus.SUCCEEDED && ownershipComplete && !!promotions.productsEligibleForDirectPromotions && numContactsSucceededCheck(state) && marketingContactsOnRenewalSucceededCheck(state) && requiredOnboardingStatus === RequestStatus.SUCCEEDED;
};
export const hasOnlyOwnershipCheckFailedSelector = state => {
  const productsStatus = fetchProductsStatus(state);
  const ownershipStatus = fetchProductInventoryStatus(state);
  const promotionsStatus = fetchPromotionsStatus(state);
  const requiredOnboardingStatus = fetchRequiredOnboardingStatus(state);
  return ownershipStatus === RequestStatus.FAILED && !(productsStatus === RequestStatus.FAILED || promotionsStatus === RequestStatus.FAILED || !numContactsSucceededCheck(state) || requiredOnboardingStatus === RequestStatus.FAILED);
};
export const hasPricingAndPurchasingFailedSelector = state => {
  const productsStatus = fetchProductsStatus(state);
  const ownershipStatus = fetchProductInventoryStatus(state);
  const promotionsStatus = fetchPromotionsStatus(state);
  const requiredOnboardingStatus = fetchRequiredOnboardingStatus(state);
  const canCheckForMarketingContactsOnRenewal = productsStatus === RequestStatus.SUCCEEDED && ownershipStatus === RequestStatus.SUCCEEDED;
  return productsStatus === RequestStatus.FAILED || ownershipStatus === RequestStatus.FAILED || promotionsStatus === RequestStatus.FAILED || !numContactsSucceededCheck(state) || canCheckForMarketingContactsOnRenewal && !marketingContactsOnRenewalSucceededCheck(state) || requiredOnboardingStatus === RequestStatus.FAILED;
};
export const hasPurchaseMotionsSucceededSelector = state => {
  const purchaseMotionStatus = fetchPurchaseMotionStatus(state);
  return purchaseMotionStatus === RequestStatus.SUCCEEDED;
};
export const hasPurchaseMotionsFailedSelector = state => {
  const purchaseMotionStatus = fetchPurchaseMotionStatus(state);
  return purchaseMotionStatus === RequestStatus.FAILED;
};
export const hasProductsSucceededSelector = state => {
  const productsStatus = fetchProductsStatus(state);
  return productsStatus === RequestStatus.SUCCEEDED;
};
export const hasSeatsInventorySucceededSelector = state => {
  const seatsInventoryStatus = fetchSeatsInventoryStatus(state);
  return seatsInventoryStatus === RequestStatus.SUCCEEDED;
};
export const hasSeatsInventoryFailedSelector = state => {
  const seatsInventoryStatus = fetchSeatsInventoryStatus(state);
  return seatsInventoryStatus === RequestStatus.FAILED;
};
export const hasPromotionsSucceededSelector = state => {
  const promotionsStatus = fetchPromotionsStatus(state);
  return promotionsStatus === RequestStatus.SUCCEEDED;
};
export const isMerchCardCTAsDataLoadingSelector = state => {
  const hasPurchaseMotionsSucceeded = hasPurchaseMotionsSucceededSelector(state);
  const hasProductsSucceeded = hasProductsSucceededSelector(state);
  const hasPromotionsSucceeded = hasPromotionsSucceededSelector(state);
  return !hasPurchaseMotionsSucceeded || !hasProductsSucceeded || !hasPromotionsSucceeded;
};
export const hasOfferDataLoadedSelector = state => {
  const hasProductsSucceeded = hasProductsSucceededSelector(state);
  const hasPromotionsSucceeded = hasPromotionsSucceededSelector(state);
  return hasProductsSucceeded && hasPromotionsSucceeded;
};